import { render, staticRenderFns } from "./RolesAndAccess.vue?vue&type=template&id=3c452d66"
import script from "./RolesAndAccess.vue?vue&type=script&lang=ts"
export * from "./RolesAndAccess.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports